import { style } from "typestyle";

export const container = style({
  marginBottom: "2rem"
});

export const error = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",

  $nest: {
    div: {
      marginBottom: "1rem"
    }
  }
});
